import { render, staticRenderFns } from "./ParametreConfigMessage.vue?vue&type=template&id=3525f352&scoped=true"
import script from "./ParametreConfigMessage.vue?vue&type=script&lang=js"
export * from "./ParametreConfigMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525f352",
  null
  
)

export default component.exports